var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order_box" },
    [
      _c(
        "div",
        { staticClass: "page_title order_title" },
        [_c("custom-breadcrumb")],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "search-box" },
        [
          _c(
            "el-select",
            {
              attrs: { clearable: "", placeholder: "Type" },
              on: {
                change: function($event) {
                  return _vm.changSelectHandel()
                }
              },
              model: {
                value: _vm.selectData.type,
                callback: function($$v) {
                  _vm.$set(_vm.selectData, "type", $$v)
                },
                expression: "selectData.type"
              }
            },
            _vm._l(_vm.typeList, function(item) {
              return _c("el-option", {
                key: item.value,
                attrs: { label: item.label, value: item.value }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticStyle: { "margin-left": "20px" },
              attrs: { clearable: "", placeholder: "Refund Status" },
              on: {
                change: function($event) {
                  return _vm.changSelectHandel()
                }
              },
              model: {
                value: _vm.selectData.status,
                callback: function($$v) {
                  _vm.$set(_vm.selectData, "status", $$v)
                },
                expression: "selectData.status"
              }
            },
            _vm._l(_vm.statusList, function(item) {
              return _c("el-option", {
                key: item.value,
                attrs: { label: item.label, value: item.value }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "date_text" }, [_vm._v("Create Time")]),
          _vm._v(" "),
          _c("el-date-picker", {
            attrs: {
              type: "daterange",
              align: "right",
              "value-format": "yyyy-MM-dd",
              "start-placeholder": "Start Date",
              "end-placeholder": "End Date"
            },
            on: { change: _vm.changeDateRange },
            model: {
              value: _vm.defalutValue,
              callback: function($$v) {
                _vm.defalutValue = $$v
              },
              expression: "defalutValue"
            }
          }),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "search_input",
            attrs: {
              "prefix-icon": "el-icon-search",
              placeholder:
                "Search orders by order,SKU,Product Name,Retailer Email",
              clearable: ""
            },
            model: {
              value: _vm.selectData.keyWords,
              callback: function($$v) {
                _vm.$set(_vm.selectData, "keyWords", $$v)
              },
              expression: "selectData.keyWords"
            }
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "search-btn",
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.changSelectHandel()
                }
              }
            },
            [_vm._v("Search")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page_table" },
        [
          _c(
            "el-table",
            {
              staticStyle: {
                width: "100%",
                "margin-top": "20px",
                height: "calc(100vh - 310px)"
              },
              attrs: {
                data: _vm.serviceOrderList,
                height: "calc(100vh - 310px)",
                stripe: ""
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "createdAt",
                  label: "Create Time/Service Order ID",
                  width: "220"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", { staticStyle: { color: "#707070" } }, [
                          _vm._v(_vm._s(scope.row.createAt))
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(scope.row.sid))])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Order ID", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.orderId))])]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Retailer", width: "220" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.userSource == 1
                          ? _c("img", {
                              staticClass: "little_logo",
                              attrs: {
                                src:
                                  "https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-logo.png",
                                alt: ""
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(scope.row.retailerName))]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(scope.row.remark))])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Type", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.getType(scope.row.type)))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Refund Status", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.getStatus(scope.row.status)))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Action", width: "350" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.status == 1
                          ? _c(
                              "el-button",
                              {
                                staticClass: "action_button",
                                attrs: {
                                  type: "primary",
                                  loading: _vm.actionLoading
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.showReviewDialog(
                                      true,
                                      scope.row.sid
                                    )
                                  }
                                }
                              },
                              [_vm._v("Pass")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == 1
                          ? _c(
                              "el-button",
                              {
                                staticClass: "action_button",
                                attrs: {
                                  type: "primary",
                                  loading: _vm.actionLoading
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.showReviewDialog(
                                      false,
                                      scope.row.sid
                                    )
                                  }
                                }
                              },
                              [_vm._v("Reject")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == 3
                          ? _c(
                              "el-button",
                              {
                                staticClass: "action_button",
                                attrs: { type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.showArbitrationVisible(
                                      scope.row.sid
                                    )
                                  }
                                }
                              },
                              [_vm._v("Submission of Vouchers")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "action_button",
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.gotoRefund(scope.row.sid)
                              }
                            }
                          },
                          [_vm._v("View")]
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Total", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            "$" + _vm._s(scope.row.refundTotalAmount.toFixed(2))
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Brand", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.brandName))])]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("Pagination", {
            attrs: {
              currentPage: _vm.selectData.pageNo,
              total: _vm.selectData.total,
              pageSize: _vm.selectData.pageSize
            },
            on: {
              handleSizeChange: _vm.handleSizeChange,
              handleCurrentChange: _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("review-dialog", {
        attrs: {
          reviewVisible: _vm.reviewVisible,
          action: _vm.action,
          reason: _vm.reason
        },
        on: { back: _vm.back, reviewServiceOrder: _vm.reviewServiceOrder }
      }),
      _vm._v(" "),
      _c("arbitration-dialog", {
        attrs: {
          arbitrationVisible: _vm.arbitrationVisible,
          serviceOrderId: _vm.serviceOrderId
        },
        on: {
          backArbitrationVisible: _vm.backArbitrationVisible,
          loadData: _vm.loadData
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4dbed0f3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dbed0f3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/service-order/service-order-list.vue
// module id = Ijh0
// module chunks = 2